import { clear_tokens } from "functions";

const Logout = () => {
	clear_tokens();

	return null;
};

export default Logout;
